// File: src/components/opportunity/MarketInfographic.js

import React from 'react';
import styles from './MarketInfographic.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

function MarketInfographic({ eyebrow, heading, subheading, image, alt, bg, landscape }) {
  return (
    <section className={cn(styles.section, bg === 'secondary' && styles.sectionSecondary)}>
      <div className="site-container">

        <ScrollAnimation className={styles.header}>
          <p className={cn(styles.eyebrow, bg === 'secondary' && styles.eyebrowDark)}>
            {eyebrow}
          </p>
          <h2 className={cn(styles.heading, bg === 'secondary' && styles.headingDark)}>
            {heading}
          </h2>
          <p className={cn(styles.subheading, bg === 'secondary' && styles.subheadingDark)}>
            {subheading}
          </p>
        </ScrollAnimation>

        <ScrollAnimation
          className={cn(
            styles.imageWrap,
            landscape && styles.imageWrapLandscape
          )}
          delay={150}
        >
          <img
            src={image}
            alt={alt}
            className={styles.image}
          />
        </ScrollAnimation>

      </div>
    </section>
  );
}

export default MarketInfographic;